// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "customer." + chunkId + "." + {"libs_customer_customer-inventory-v1_src_index_ts":"260627b8385089b4","libs_customer_customer-documents-v1_src_index_ts":"2e96d45e70f31832","libs_customer_customer-approvals-v1_src_index_ts":"85eb9d7dda9fcda4"}[chunkId] + ".js";
};